import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { getSchoolFromUrl } from './utils/utils';

export const msalInterceptorFn: HttpInterceptorFn = (req, next) => {
  const msalService = inject(MsalService);
  const escolaNome = getSchoolFromUrl()

  // Aqui, defina as URLs que você quer interceptar
  const urlsNeedingToken = [
    'localhost:44330',
    'localhost:44327',
    'localhost:44339',
    'saguiedualunoapi.azurewebsites.net',
    'saguicontrolapi.azurewebsites.net',
    'portalpais-erbmawffekgudqg4.brazilsouth-01.azurewebsites.net',
    'saguicontrolapi-homologacao.azurewebsites.net',
    'saguieduapi-homologacao.azurewebsites.net',
    'portalpais-homologacao-hsfchbfph8embnhn.brazilsouth-01.azurewebsites.net',
    'portalpaisapi.virescoerp.com.br',
    'homologacao.portalpaisapi.virescoerp.com.br',
    'portalpaishomologacao.virescoerp.com.br',
  ];

  // Checar se a URL é do seu backend
  if (urlsNeedingToken.some(url => req.url.includes(url))) {

    const account = msalService.instance.getActiveAccount();
    if (account) {
      return from(
        msalService.instance.acquireTokenSilent({
          account,
          scopes: environment.scopes
        })
      ).pipe(
        switchMap(result => {
          const cloned = req.clone({
            headers: req.headers
            .set('Authorization', `Bearer ${result.accessToken}`)
            .set('X-Tenant-Subdomain', escolaNome ? escolaNome : 'default') // Adiciona o nome da escola no header
          });
          return next(cloned);
        })
      );
    }
  }

  return next(req);
};
